<template>
  <div class="d-flex text-left">
    <form @submit.prevent class="w-100">
      <b-input-group class="panel-input-serach">
        <b-form-input
          id="inventorySearchBook"
          class="input-serach"
          placeholder="ค้นหาชื่อสินค้า, SKU, คอลเลคชั่นสินค้า"
          v-model="filter.search"
          v-on:keyup.13="enterFilter"
        ></b-form-input>
        <b-input-group-prepend id="btnInventorySearchBook">
          <span class="icon-input m-auto pr-2">
            <font-awesome-icon icon="search" title="View" />
          </span>
        </b-input-group-prepend>
      </b-input-group>
    </form>

    <b-button
      id="btnInventoryBookFilter"
      v-b-toggle.sideBarInventoryBookFilter
      class="btn-filter size-btn-filter ml-2"
    >
      <font-awesome-icon
        icon="filter"
        title="filter-btn"
        class="main-color mr-0"
      />
      <span class="d-none d-sm-inline">ตัวกรอง </span>
    </b-button>

    <b-sidebar
      id="sideBarInventoryBookFilter"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      ref="filterSidebar"
      aria-labelledby="sidebar-filter-title"
      no-header
    >
      <template #default="{ hide }">
        <div class="p-3 sidebar-filter-header d-flex justify-content-between">
          <h4 id="sidebar-filter-title" class="m-0">ตัวกรอง</h4>
          <font-awesome-icon
            class="my-auto"
            id="btnInventoryBookHideFilter"
            icon="times-circle"
            color="#FFFFFF"
            @click="hide"
          />
        </div>
        <div class="px-3 py-2">
          <div class="mt-2">
            <form @submit.prevent class="w-100">
              <b-input-group class="panel-input-serach">
                <b-form-input
                  id="inventorySearchBook"
                  class="input-serach"
                  placeholder="ค้นหาชื่อสินค้า, SKU, คอลเลคชั่นสินค้า"
                  v-model="filter.search"
                  v-on:keyup.13="enterFilter"
                ></b-form-input>
                <b-input-group-prepend>
                  <span class="icon-input m-auto pr-2">
                    <font-awesome-icon icon="search" title="View" />
                  </span>
                </b-input-group-prepend>
              </b-input-group>
            </form>
          </div>
          <div class="mt-3">
            <div class="font-weight-bold mb-2">สถานะ</div>
            <b-form-group>
              <div class="d-flex flex-row flex-wrap">
                <b-form-checkbox
                  v-for="(status, index) in campaignStatus"
                  :id="'inventoryBookFilterStatus' + status.campaignId"
                  :key="index"
                  :value="status.campaignId"
                  class="mb-2 w-100"
                  v-model="filter.CampaignStatus"
                  >{{ status.campaignStatus }}</b-form-checkbox
                >
              </div>
            </b-form-group>
          </div>

          <div class="mt-3">
            <div class="font-weight-bold mb-2">ช่องทางการขาย</div>
            <b-form-group>
              <div class="d-flex flex-row flex-wrap">
                <b-form-checkbox
                  v-for="(channel, index) in salesChannel"
                  :id="'inventoryBookFilterChannel' + channel.salesChannelId"
                  :key="index"
                  :value="channel.salesChannelId"
                  class="mb-2 w-100"
                  v-model="filter.SalesChannel"
                  >{{ channel.salesChannelName }}</b-form-checkbox
                >
              </div>
            </b-form-group>
          </div>

          <div class="mt-3">
            <p class="mb-1">วันที่แคมเปญ (เริ่มต้น)</p>
            <div class="input-container">
              <datetime
                :input-style="styleDatetime"
                v-model="filter.StartDate"
                placeholder="วว / ดด / ปป"
                value-zone="Asia/Bangkok"
                ref="startCampaignDate"
                input-id="inventoryBookFilterStartDate"
              >
              </datetime>
              <div
                class="icon-container text-right"
                @click="$refs.startCampaignDate.isOpen = true"
              >
                <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
              </div>
            </div>
          </div>
          <div class="mt-3">
            <p class="mb-1">วันที่แคมเปญ (สิ้นสุด)</p>
            <div class="input-container">
              <datetime
                :input-style="styleDatetime"
                v-model="filter.EndDate"
                placeholder="วว / ดด / ปป"
                value-zone="Asia/Bangkok"
                ref="endCampaignDate"
                input-id="inventoryBookFilterEndDate"
              >
              </datetime>
              <div
                class="icon-container text-right"
                @click="$refs.endCampaignDate.isOpen = true"
              >
                <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
              </div>
            </div>
          </div>
          <div class="mt-3">
            <p class="mb-1">วันที่จองสินค้า (เริ่มต้น)</p>
            <div class="input-container">
              <datetime
                :input-style="styleDatetime"
                v-model="filter.ReserveStartDate"
                value-zone="Asia/Bangkok"
                placeholder="วว / ดด / ปป"
                ref="startBookingDate"
                input-id="inventoryBookFilterReserveStartDate"
              >
              </datetime>
              <div
                class="icon-container text-right"
                @click="$refs.startBookingDate.isOpen = true"
              >
                <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
              </div>
            </div>
          </div>
          <div class="mt-3">
            <p class="mb-1">วันที่จองสินค้า (สิ้นสุด)</p>
            <div class="input-container">
              <datetime
                :input-style="styleDatetime"
                v-model="filter.ReserveEndDate"
                placeholder="วว / ดด / ปป"
                value-zone="Asia/Bangkok"
                ref="endBookingDate"
                input-id="inventoryBookFilterReserveEndDate"
              >
              </datetime>
              <div
                class="icon-container text-right"
                @click="$refs.endBookingDate.isOpen = true"
              >
                <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <div
          class="
            d-flex
            justify-content-between
            shadow
            align-items-center
            border-top
          "
        >
          <div class="w-100">
            <b-button
              block
              size="lg"
              variant="light"
              class="text-dark w-100 border-radius-0 btn-clear-filter"
              @click="clearFilter"
              >ล้างตัวกรอง</b-button
            >
          </div>
          <div class="w-100">
            <b-button
              @click="onSubmitCampaignFilter"
              block
              size="lg"
              variant="light"
              class="text-body btn-main w-100 border-radius-0"
            >
              ยืนยัน
            </b-button>
          </div>
        </div>
      </template>
    </b-sidebar>
    <b-button
      class="btn-main w-50 border-radius-0 ml-2"
      @click="$router.push('/inventory/create-campaign/0').catch(() => {})"
    >
      สร้างรายการจอง
    </b-button>
  </div>
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect";
export default {
  name: "InventoryBookProductFilter",
  components: {
    InputSelect,
  },
  props: {},
  created() {
    this.getListFilter();
  },
  data() {
    return {
      filter: {
        search: "",
        StartDate: "",
        EndDate: "",
        ReserveStartDate: "",
        ReserveEndDate: "",
        pageSize: 10,
        page: 1,
        SalesChannel: [],
        CampaignStatus: [],
      },
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      salesChannel: [],
      campaignStatus: [],
    };
  },
  methods: {
    onSubmitCampaignFilter() {
      this.$emit("onSubmitCampaignFilter", this.filter);
      this.$refs.filterSidebar.hide();
    },
    enterFilter(event) {
      console.log(`event`, event);
      if (event.which === 13) {
        this.onSubmitCampaignFilter();
      }
    },
    getListFilter() {
      this.axios
        .get(`${this.$baseUrl}/stockdistribute/campaign/config`)
        .then((data) => {
          this.salesChannel = data.detail.salesChannel;
          this.campaignStatus = data.detail.campaignStatus;
        });
    },
    clearFilter() {
      this.filter = {
        search: "",
        StartDate: "",
        EndDate: "",
        ReserveStartDate: "",
        ReserveEndDate: "",
        pageSize: 10,
        page: 1,
        SalesChannel: [],
        CampaignStatus: [],
      };
      this.$emit("onSubmitCampaignFilter", this.filter);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
}

.icon-container {
  flex: 1 1 auto;
  cursor: text;
}
.size-btn-filter {
  width: 219.7px;
}
</style>
